import React from 'react';
import strikon from '../data/strikon.png';


let animation = null;
// let style = {

// }

class PulsingStrike extends React.Component {
  constructor(props) {
    super(props);
    this.canvasRef = React.createRef();
    this.size = this.props.size;
    this.width = this.size;
    this.height = this.size;
    this.data = new Uint8Array(this.size * this.size * 4);
    this.animateDot = this.animateDot.bind(this);
    this.onClick = this.props.onClick;
  }

  componentDidMount() {
    animation = window.requestAnimationFrame(this.animateDot);
  }

  animateDot() {
    const duration = 1000;
    const t = (performance.now() % duration) / duration;
     
    const radius = this.size / 2 * 0.2;
    const outerRadius = this.size / 2 * 0.7 * t + radius;
    const canvas = this.canvasRef.current;
    let context;

    if (canvas) {
      context = canvas.getContext('2d');
      context.clearRect(0, 0, this.width, this.height);

      // draw outer circle
      context.beginPath();
      context.arc(this.width / 2, this.height / 2, outerRadius, 0, Math.PI * 2);
      context.fillStyle = 'rgba(255, 0, 0,' + (1 - t) + ')';
      context.fill();
       
      // update this image's data with data from the canvas
      // this.data = context.getImageData(0, 0, this.width, this.height).data;
      animation = window.requestAnimationFrame(this.animateDot);
    }
  }

  onClick() {
    this.props.onClick()
  }

  componentWillUnmount() {
    window.cancelAnimationFrame(animation);
  }

  render() {
    return (
      <div style={{
        position: "relative",
        width: "30px",
        height: "30px"
      }}>
        <img 
          src={strikon} 
          style={{
            position: "absolute",
            width: "20px",
            height: "20px",
            top: "5px",
            left: "5px"
          }}
          alt="collision emoji"
          onClick={this.onClick}
        />
        <canvas className="strikeon" width={this.width} height={this.height} ref={this.canvasRef}/>
      </div>
    )
  }
}

export default PulsingStrike


// WEBPACK FOOTER //
// ./src/components/strategy/wsde/pulsingStrike.js